<template>
  <v-row class="bandeau_noir" no-gutters>
    <v-col cols="3" offset="9" class="margin_right pa-3" v-click-outside="() => { visible = false }">
      <span @click="visible = true" v-if="!visible">SE CONNECTER EN TANT QUE {{ commercial.nom.toUpperCase() }}</span>
      <v-select
        :items="commerciaux"
        item-value="id_utilisateur"
        item-text="nom"
        v-model="selected"
        light
        outlined
        dense
        color="#FFF"
        v-if="visible"
        background-color="#fff"
        clearable
        @change="selectedCommercial"
        hide-details
        :menu-props="{ zIndex: 20 }"
      ></v-select>
    </v-col>
  </v-row>
</template>

<script>
import api from '@/api/user';

export default {
  name: "AdminHeader",
  data() {
    return {
      visible: false,
      commerciaux: [],
      selected: '',
      commercial: this.$store.state.AsUser,
    };
  },
  methods: {
    selectedCommercial() {
      this.visible = false;
      this.commercial = this.selected
        ? this.commerciaux.find(c => this.selected === c.id_utilisateur)
        : { nom: '', id_utilisateur: '' };
      this.$store.commit('connectedAs', this.commercial);
      this.$emit('selectedCommercial', { count: 1 });
    },
  },
  created() {
    api.getCommerciaux().then((res) => {
      this.commerciaux = res.data.users;
    });
  },
};
</script>

<style scoped>
.bandeau_noir {
  background-color: black;
  color: white;
  text-align: end;
}
.margin_right {
  font-size: 0.8em;
}
::v-deep fieldset {
  display: none;
}
</style>
